import React from 'react';

import { Box, Heading } from '@rebass/emotion';

import Accordian from './Accordian';
import colors from '@theme/colors';
import { graphql, useStaticQuery } from 'gatsby';
import { findMatchingNodePath } from '@helpers/scripts';

const FAQ = ({ location }: any) => {
  const {
    allTrialsJson: { nodes },
  } = useStaticQuery(query);
  const faqs = findMatchingNodePath(nodes, location).strings.faqs;
  console.log('formDateGroup', faqs);
  return (
    <section id="faq" style={{ paddingBottom: 0 }}>
      <Box pt={5}>
        <Box py={5} bg="lightgray">
          <Box width={[0.9, 0.9, 800, 1150]} mx="auto" pr={[3, 0, 0]}>
            <Heading
              as="h2"
              color={colors.grayDark10}
              fontSize={['2.3rem', '2.5rem', '2.5rem', '2.5rem']}
              ml={[1, 1, 80, 0]}
            >
              FAQs
            </Heading>

            <Box className="faq" py={5} width={[1, 1, 700, 920]} ml={[1, 1, 80, 100]}>
              {faqs &&
                faqs.map((faq, key) => (
                  <Accordian
                    key={key}
                    content={faq.content}
                    id={faq.id}
                    title={faq.title}
                    color={`${colors.grayDark10} !important`}
                  />
                ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </section>
  );
};

export default FAQ;

const query = graphql`
  {
    allTrialsJson {
      nodes {
        path
        strings {
          faqs {
            id
            title
            content
          }
        }
      }
    }
  }
`;
